import plantsClient from '@/core/services/plants';
import { Vue, Options } from 'vue-class-component';
import { cloneObject, defaultNewEntrancePlant } from '@/core/utils/utils';
import { EntrancePlantDetailDTO, EntrancePlantHeadCreateDTO, EntrancePlantInfoCreateDTO, EntrancePlantStructureCreateDTO, PePlantConfig, PePlantConfigDTO } from '@/../client-generator/generated-clients/plants';
import DialogEntrancePlantCreateStep1 from './DialogEntrancePlantCreate/DialogEntrancePlantCreateStep1/DialogEntrancePlantCreateStep1.vue';
import DialogEntrancePlantCreateStep2 from './DialogEntrancePlantCreate/DialogEntrancePlantCreateStep2/DialogEntrancePlantCreateStep2.vue';
import DialogEntrancePlantCreateRiserOrNot from './DialogEntrancePlantCreate/DialogEntrancePlantCreateRiserOrNot/DialogEntrancePlantCreateRiserOrNot.vue';
import DialogEntrancePlantCreateStep3 from './DialogEntrancePlantCreate/WithoutRiserInterface/DialogEntrancePlantCreateStep3/DialogEntrancePlantCreateStep3.vue';
import DialogEntrancePlantCreateStep4 from './DialogEntrancePlantCreate/WithoutRiserInterface/DialogEntrancePlantCreateStep4/DialogEntrancePlantCreateStep4.vue';
import DialogEntrancePlantCreateStep5 from './DialogEntrancePlantCreate/WithoutRiserInterface/DialogEntrancePlantCreateStep5/DialogEntrancePlantCreateStep5.vue';
import DialogEntrancePlantCreateStep6 from './DialogEntrancePlantCreate/WithoutRiserInterface/DialogEntrancePlantCreateStep6/DialogEntrancePlantCreateStep6.vue';
import DialogEntrancePlantCreateStep7 from './DialogEntrancePlantCreate/WithoutRiserInterface/DialogEntrancePlantCreateStep7/DialogEntrancePlantCreateStep7.vue';
import DialogEntrancePlantCreateSetupGate from './DialogEntrancePlantCreate/WithRiserInterface/DialogEntrancePlantCreateSetupGate/DialogEntrancePlantCreateSetupGate.vue';
import DialogEntrancePlantCreateSetupRiser from './DialogEntrancePlantCreate/WithRiserInterface/DialogEntrancePlantCreateSetupRiser/DialogEntrancePlantCreateSetupRiser.vue';
import DialogEntrancePlantCreateSetupBuilding from './DialogEntrancePlantCreate/WithRiserInterface/DialogEntrancePlantCreateSetupBuilding/DialogEntrancePlantCreateSetupBuilding.vue';
import DialogEntrancePlantCreateSetupAddBuildings from './DialogEntrancePlantCreate/WithRiserInterface/DialogEntrancePlantCreateSetupAddBuildings/DialogEntrancePlantCreateSetupAddBuildings.vue';
import DialogEntrancePlantCreateBuildingsRecap from './DialogEntrancePlantCreate/WithRiserInterface/DialogEntrancePlantCreateBuildingsRecap/DialogEntrancePlantCreateBuildingsRecap.vue';
import DialogEntrancePlantCreateSetupBuildingBRFA from './DialogEntrancePlantCreate/WithRiserInterface/DialogEntrancePlantCreateSetupBuildingBRFA/DialogEntrancePlantCreateSetupBuildingBRFA.vue';
import DialogEntrancePlantCreateBRFACodeExample from './DialogEntrancePlantCreate/WithRiserInterface/DialogEntrancePlantCreateBRFACodeExample/DialogEntrancePlantCreateBRFACodeExample.vue';


@Options({
  name: 'WizardEntrancePlant',
  components: {
    DialogEntrancePlantCreateStep1,
    DialogEntrancePlantCreateStep2,
    DialogEntrancePlantCreateStep3,
    DialogEntrancePlantCreateStep4,
    DialogEntrancePlantCreateStep5,
    DialogEntrancePlantCreateStep6,
    DialogEntrancePlantCreateStep7,
    DialogEntrancePlantCreateSetupGate,
    DialogEntrancePlantCreateSetupRiser,
    DialogEntrancePlantCreateSetupBuilding,
    DialogEntrancePlantCreateSetupAddBuildings,
    DialogEntrancePlantCreateBuildingsRecap,
    DialogEntrancePlantCreateSetupBuildingBRFA,
    DialogEntrancePlantCreateRiserOrNot,
    DialogEntrancePlantCreateBRFACodeExample
  },
  props: {
    plantId: {
      type: Number,
      required: false,
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  emits: ['exit-wizard', 'plant-edited', 'update'],
})
export default class WizardEntrancePlant extends Vue {
  plantId: number | null = null;
  isLoading = false;
  nextEnabled = true;
  structureCreate: EntrancePlantStructureCreateDTO | null = null;
  isEdit!: boolean;
  dialogStep = 1;
  entrancePlant: EntrancePlantDetailDTO = cloneObject(defaultNewEntrancePlant);

  dialogStepEntrancePlantComponent = 'DialogEntrancePlantCreateStep1';

  mounted() {
    this.initFormPlant();
  }

  async initFormPlant() {
    if (this.plantId) {
      await this.fetchPePlant(this.plantId);
    } else {
      this.entrancePlant = cloneObject(defaultNewEntrancePlant);
      this.structureCreate = new EntrancePlantStructureCreateDTO({
        pePlantConfig: new PePlantConfigDTO(),
        headCreate: new EntrancePlantHeadCreateDTO(),
        infoCreate: new EntrancePlantInfoCreateDTO(),
        buildingsCreate: [],
        gateCreate: [],
        gateConfigStructure: {},
        plantConfigStructure: {},
        wizardStep: 1,
      })
    }
  }

  async handleNext(nextComponentName: string, plantId: number) {
    if (plantId) {
      this.$emit('update', plantId);
      await this.fetchPePlant(plantId);
    } else {
      await this.fetchPePlant(this.plantId);
    }
    this.dialogStepEntrancePlantComponent = nextComponentName;
  }

  async handleBack(prevComponentName: string) {
    if (!prevComponentName) this.$emit('exit-wizard');
    else this.dialogStepEntrancePlantComponent = prevComponentName;
  }

  async handleEditedPlant() {
    if (this.plantId && this.isEdit) 
      this.$emit('plant-edited');
  }

  async fetchPePlant(peId: number | null) {
    if (!peId) return;
    this.isLoading = true;

    try {
      this.entrancePlant = await plantsClient.entranceplantGET(peId, undefined);
    } catch (error) {
      this.$toast.add({
        severity: 'error',
        summary: this.$t('general.operationError'),
        closable: true,
        life: 6000,
      });
    } finally {
      this.isLoading = false;
    }
  }

  handleStepLoading(isLoading: boolean) {
    this.isLoading = isLoading;
  }
}
